import { NewsCard } from './NewsCard.jsx';

/**
 * Grid of NewsCards. `columns` is a *desktop* hint; the layout uses
 * auto-fit so cards collapse to the next break (3 → 2 → 1) automatically
 * as the container narrows. `min(100%, Npx)` clamps each card to the
 * full width on phones so a single column always fits.
 */
const MIN_PER_COL = {
  3: 280,   // 3-col list pages collapse to 2 around 880px and 1 around 580px
  2: 380,   // 2-col grids
  1: 9999,  // force single column
};

export function NewsGrid({ items = [], columns = 3, variant = 'default', emptyText = 'No items to show.' }) {
  if (!items.length) {
    return (
      <p style={{ color: 'var(--ink-3)', padding: '40px 0', textAlign: 'center' }}>{emptyText}</p>
    );
  }
  const minPx = MIN_PER_COL[columns] ?? 280;
  return (
    <div className="news-grid" style={{
      display: 'grid',
      gap: 32,
      gridTemplateColumns: `repeat(auto-fit, minmax(min(100%, ${minPx}px), 1fr))`,
    }}>
      {items.map((it) => (
        <NewsCard key={it.id} item={it} variant={variant} />
      ))}
    </div>
  );
}
